import { W as WuiDivider$1, d as defineCustomElement$1 } from './p-D-k_i6-R.js';

const WuiDivider = WuiDivider$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDivider, defineCustomElement };
